import store from '@/store';

export function authUserHasPrivilegeAndAction(privilege: string, action: string): boolean {
    const user: any = store.getters.getUser;
    const privilegeAndActionName: string = action + '-' + privilege;

    return user?.privileges.includes(privilegeAndActionName) ?? false;
}
